import { Flex, Switch, Heading, Text, TextArea } from '@scale/scaleui-radix';
import { AuditRubricCriterion } from '@scale/shared-types';

export const FillCriterionJustification = ({
  feedback,
  setFeedback,
}: {
  feedback: string;
  setFeedback: (feedback: string) => void;
}) => {
  return (
    <Flex direction="column" gap="2">
      <Text weight="medium">Feedback</Text>
      <TextArea size="2" value={feedback} onChange={e => setFeedback(e.target.value)} />
    </Flex>
  );
};

const ViewCriterionJustification = ({ criterion }: { criterion: AuditRubricCriterion }) => {
  return (
    <Flex direction="column" gap="2">
      <Text color="neutral">Justification</Text>
      <Text>{criterion.requiresJustification ? 'Required' : 'Not required'}</Text>
    </Flex>
  );
};

const EditCriterionJustification = ({
  criterion,
  setCriterion,
  error,
}: {
  criterion: AuditRubricCriterion;
  setCriterion: (criterion: AuditRubricCriterion) => void;
  error?: string;
}) => {
  const setRequireJustification = (requiresJustification: boolean) => {
    setCriterion({ ...criterion, requiresJustification });
  };

  return (
    <Flex direction="column" gap="2">
      <Flex direction="row" gap="2">
        <Switch
          checked={criterion.requiresJustification}
          onCheckedChange={setRequireJustification}
        />
        <Heading size="2">Require rating justification</Heading>
      </Flex>
      <Text size="1" color="neutral">
        Justification requires auditors to provide task feedback.
      </Text>
      {error && (
        <Text size="2" color="red">
          {error}
        </Text>
      )}
    </Flex>
  );
};

export const CriterionJustification = ({
  criterion,
  setCriterion,
  isEditingCriterion,
  error,
}: {
  criterion: AuditRubricCriterion;
  setCriterion: (criterion: AuditRubricCriterion) => void;
  isEditingCriterion: boolean;
  error?: string;
}) => {
  return isEditingCriterion ? (
    <EditCriterionJustification criterion={criterion} setCriterion={setCriterion} error={error} />
  ) : (
    <ViewCriterionJustification criterion={criterion} />
  );
};
